module.exports = __webpack_public_path__ + "static/media/Riverbend_Malt_billhead_style_mural_progess_3_Asheville_NC_2018.507ab947.webp";